/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import merge from 'lodash/merge';
import * as types from '../constants';

const INITIALSTATE = {
    result: {},
};

export default function permit(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case types.GET_PERMIT:
            st.result = action.payload;
            delete st.fetch_err;
            return st;

        case types.GET_PERMIT_ERROR:
            st.fetch_err = action.error;
            return st;

        case types.GET_ALL_PERMITS: {
            const permitId = action.payload.id;
            st.allPermits = { ...st.allPermits, [permitId]: action.payload };
            delete st.fetch_err;
            return st;
        }

        case types.GET_ALL_PERMITS_ERROR:
            st.fetch_err = action.error;
            return st;

        case types.GET_AGGREGATE_SEASON_RULES:
            st.agg_season_rules = action.payload;
            delete st.agg_season_rules_err;
            return st;

        case types.GET_AGGREGATE_SEASON_ERROR:
            st.agg_season_rules_err = action.error;
            return st;

        case types.GET_PERMIT_RESERVATION_ALERT:
            st.reservation_alert = action.payload;
            delete st.reservation_alert_err;
            return st;

        case types.GET_PERMIT_RESERVATION_ALERT_ERROR:
            st.reservation_alert_err = action.error;
            delete st.reservation_alert;
            return st;

        case types.GET_PERMIT_GALLERY:
            return { ...st, gallery: action.payload };

        case types.VERIFY_LOTTERY:
            st.verify_lottery = action.payload;
            delete st.verify_lottery_err;
            return st;

        case types.VERIFY_LOTTERY_ERROR:
            st.verify_lottery_err = action.error;
            delete st.verify_lottery;
            return st;

        case types.GET_LOTTERY:
            st.lottery = action.payload;
            delete st.lottery_err;
            return st;

        case types.GET_LOTTERY_ERROR:
            st.lottery_err = action.error;
            return st;

        case types.GET_LOTTERIES:
            st.lotteries = action.payload;
            delete st.lotteries_err;
            return st;

        case types.GET_LOTTERIES_ERROR:
            st.lotteries_err = action.error;
            return st;

        case types.GET_LOTTERIES_DAILY:
            st.daily_lotteries = action.payload;
            delete st.daily_lotteries_error;
            return st;

        case types.GET_LOTTERIES_DAILY_ERROR:
            st.daily_lotteries_err = action.error;
            return st;

        case types.GET_ISSUANCE:
            st.issuance = action.payload;
            delete st.fetch_err;
            delete st.fetch_issuance_error;
            return st;

        case types.GET_ISSUANCE_ERROR:
            st.fetch_err = action.error;
            st.fetch_issuance_error = { msg: action.error, code: action.error_code };
            return st;

        case types.GET_ALL_ISSUANCES: {
            const resNumber = action.payload.reservation_number;
            st.allIssuances = { ...st.allIssuances, [resNumber]: action.payload };
            delete st.fetch_err;
            delete st.fetch_issuance_error;
            return st;
        }

        case types.GET_ALL_ISSUANCES_ERROR:
            st.fetch_err = action.error;
            st.fetch_issuance_error = { msg: action.error, code: action.error_code };
            return st;

        case types.GET_ISSUANCE_BY_STATUS:
            if (st.issuances === undefined) {
                st.issuances = action.payload;
            } else {
                st.issuances = { ...action.payload, ...state.issuances };
            }
            delete st.fetch_err;
            return st;

        case types.GET_ISSUANCE_ERROR_BY_STATUS:
            st.fetch_err = action.error;
            return st;

        case types.POST_ISSUANCE:
            st.issuance = action.payload;
            delete st.issuanceError;
            return st;

        case types.POST_ISSUANCE_ERROR:
            st.issuanceError = action.error;
            return st;

        case types.UPDATE_ISSUANCE:
            st.update_issuance_result = action.payload.status;
            st.updated_issuance = action.payload.issuance;
            delete st.update_issuance_error;
            return st;

        case types.UPDATE_ISSUANCE_ERROR:
            st.update_issuance_error = action.error.error;
            delete st.update_issuance_result;
            delete st.updated_issuance;
            return st;

        case types.CLEAR_ISSUANCE:
            delete st.issuance;
            return st;

        case types.SEND_CURRENT_DATE:
            st.current_date = action.payload;
            return st;

        case types.GET_AVAILABILITY:
            if (st.availabilities === undefined) {
                st.availabilities = [];
            }
            st.availabilities = {
                ...st.availabilities,
                [action.keyName]: {
                    error: undefined,
                    permitId: action.permitId,
                    divisionId: action.divisionId,
                    result: action.payload,
                },
            };
            st.availability = action.payload;
            delete st.availability_err;
            return st;

        case types.GET_AVAILABILITY_ERROR:
            if (st.availabilities === undefined) {
                st.availabilities = [];
            }
            st.availabilities = {
                ...st.availabilities,
                [action.keyName]: {
                    error: action.error,
                    permitId: action.permitId,
                    divisionId: action.divisionId,
                    result: undefined,
                },
            };
            st.availability_err = action.error;
            delete st.availability;
            return st;

        case types.GET_ALL_AVAILABILITIES:
            st.fetching_availability = true;
            if (st.availabilities === undefined) {
                st.availabilities = {};
            }
            delete st.fetching_availability;
            st.availabilities = merge({}, st.availabilities, action.payload);
            delete st.availability_err;
            return st;

        case types.GET_ALL_AVAILABILITIES_ERROR:
            st.availability_err = action.error;
            delete st.availabilities;
            return st;

        case types.GET_NEXT_AVAILABLE:
            st.next_available = action.payload;
            delete st.next_available_err;
            return st;

        case types.GET_NEXT_AVAILABLE_ERROR:
            st.get_next_available_err = action.error;
            delete st.next_available;
            return st;

        case types.CLEAR_NEXT_AVAILABLE:
            st.next_available = {};
            return st;

        case types.CLEAR_AVAILABILITIES:
            st.availabilities = {};
            return st;

        case types.SAVE_FILTERS:
            st.filters = action.payload;
            return st;

        case types.GET_RECAREA:
            st.recarea = action.payload;
            delete st.recarea_err;
            return st;

        case types.GET_RECAREA_ERROR:
            st.recarea_err = action.error;
            return st;

        case types.GET_CART:
            st.cart = action.payload;
            delete st.cart_err;
            return st;

        case types.GET_CART_ERROR:
            st.cart_err = action.payload;
            return st;

        case types.NOTIFY_LOTTERY_RESULTS:
            st.notify = action.payload;
            delete st.notify_err;
            return st;

        case types.NOTIFY_LOTTERY_RESULTS_ERROR:
            st.notify_err = action.payload;
            return st;

        case types.POST_LOTTERY:
            st.lottery = action.payload;
            delete st.lottery_err;
            return st;

        case types.POST_LOTTERY_ERROR:
            st.lottery_err = action.payload;
            return st;

        case types.GET_ISSUANCE_PDF_ERROR:
            st.fetch_err = action.error;
            return st;

        case types.GET_ISSUANCE_ACCESS_INFO:
            delete st.access_info_error;
            st.access_info = action.payload;
            return st;

        case types.GET_ISSUANCE_ACCESS_INFO_ERROR:
            delete st.access_info;
            st.access_info_err = action.error;
            return st;

        case types.GET_CAMPSITES:
            st.campsites = action.payload;
            delete st.campsites_err;
            return st;

        case types.GET_CAMPSITES_ERROR:
            st.campsites_err = action.payload;
            return st;

        case types.POST_ISSUANCE_CALCULATE_FEES:
            st.issuance_fee_difference = action.payload;
            return st;

        case types.POST_ISSUANCE_CALCULATE_FEES_ERROR:
            st.issuance_fee_difference_err = action.error;
            return st;

        case types.POST_ISSUANCE_CARTLESS:
            st.issuance = action.payload;
            delete st.error;
            return st;

        case types.SET_ISSUANCE_AFTER_CHANGE_GROUP_SIZE:
            st.issuance = action.payload;
            return st;

        case types.POST_ISSUANCE_CARTLESS_ERROR:
            st.error = action.error;
            return st;

        case types.GET_STAYLIMIT_RULE:
            st.rule_staylimit = action.payload;
            delete st.rule_staylimit_error;
            return st;

        case types.GET_STAYLIMIT_RULE_ERROR:
            st.rule_staylimit_error = action.error;
            st.rule_staylimit = { value: 0 };
            return st;

        case types.GET_ACCOUNT_EMPLOYEES:
            st.account_employees = action.employees;
            delete st.get_account_employees_error;
            return st;

        case types.GET_ACCOUNT_EMPLOYEES_ERROR:
            st.get_account_employees_error = action.error;
            return st;

        case types.VERIFY_ALTERNATE:
            st.verify_alternate_success = action.payload;
            delete st.verify_alternate_error;
            return st;

        case types.VERIFY_ALTERNATE_ERROR:
            st.verify_alternate_error = action.error;
            delete st.verify_alternate_success;
            return st;

        case types.CONFIRM_ALTERNATE:
            st.confirm_alternate_success = action.payload;
            delete st.confirm_alternate_error;
            return st;

        case types.CONFIRM_ALTERNATE_ERROR:
            st.confirm_alternate_error = action.error;
            delete st.confirm_alternate_success;
            return st;

        case types.DECLINE_ALTERNATE:
            st.decline_alternate_success = action.payload;
            delete st.decline_alternate_error;
            return st;

        case types.DECLINE_ALTERNATE_ERROR:
            st.decline_alternate_error = action.error;
            delete st.decline_alternate_success;
            return st;

        case types.FINALIZE_CHECKOUT:
            const confirmation = {
                orderID: action.payload.order_id,
                completedReservations: action.payload.completed_reservations,
                subtotal: action.payload.subtotal,
                tax: action.payload.tax,
                total: action.payload.total,
                modification: action.payload.modification,
            };
            st.order_confirmation = confirmation;
            return st;

        case types.CLEAR_ERROR:
            delete st.error;
            return st;

        case types.CLEAR_UPDATE_ISSUANCE_ERROR:
            delete st.update_issuance_error;
            return st;

        case types.CLEAR_FETCH_ERROR:
            delete st.fetch_err;
            return st;

        case types.CLEAR_CART_ERROR:
            delete st.cart_err;
            return st;

        case types.CLEAR_FETCH_ISSUANCE_ERROR:
            delete st.fetch_issuance_error;
            return st;

        case types.CLEAR_AVAILABILITY_ERROR:
            delete st.availability_err;
            return st;

        case types.CLEAR_POST_ISSUANCE_ERROR:
            delete st.issuanceError;
            return st;

        case types.CLEAR_FETCH_LOTTERY_ERROR:
            delete st.lottery_err;
            return st;

        case types.GET_EXPRESS_MEMBERSHIPS_FOR_PERMIT_BY_ID:
            st.express_memberships_for_permit_by_user = action.payload;
            return st;
        case types.GET_EXPRESS_MEMBERSHIPS_FOR_PERMIT_BY_ID_ERROR:
            st.express_memberships_for_permit_by_user_error = action.error;
            return st;

        case types.GET_ALL_EXPRESS_MEMBERSHIPS_FOR_PERMIT_BY_ID: {
            const permitId = action.payload.permit_id;
            st.all_express_memberships_for_permit_by_user = {
                ...st.all_express_memberships_for_permit_by_user,
                [permitId]: action.payload,
            };
            delete st.all_express_memberships_for_permit_by_user_error;
            return st;
        }
        case types.GET_ALL_EXPRESS_MEMBERSHIPS_FOR_PERMIT_BY_ID_ERROR:
            st.all_express_memberships_for_permit_by_user_error = action.error;
            return st;
        case types.GET_EXPRESS_MEMBERSHIP_PRINT_DATE_FOR_PERMIT_BY_ISSUANCE_ID: {
            st.permit_express_membership_issuance_print_date = {
                ...st.permit_express_membership_issuance_print_date,
                [action.permit_id]: {
                    [action.issuance_id]: action.payload,
                },
            };
            delete st.permit_express_membership_issuance_print_date_error;
            return st;
        }
        case types.GET_EXPRESS_MEMBERSHIP_PRINT_DATE_FOR_PERMIT_BY_ISSUANCE_ID_ERROR:
            st.permit_express_membership_issuance_print_date_error = action.error;
            return st;

        default:
            return st;
    }
}
